import AppStoreDark from '../../src/legacy/AppStoreDark.tsx';
export default AppStoreDark;
